import React, { useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { FiShoppingCart, FiUser } from "react-icons/fi";
import { NavLink, useLocation, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { getTotalAmount } from "../../../redux/slice/useCartSlice";
import MobileCategoryModal from "../../user/ParcoursAchat/modal/MobileCategoryModal";
import { MAIN_NAV_LINKS } from "../FrontMainNav/FrontMainNav";
import CategoriesList from "./CategoriesList";
import ConnexionModal from "./modal/ConnexionModal";
import SearchForm from "./SearchForm";
import PURE_Essence from "../../../assets/images/appImages/PURE_Essence_Logo.jpg";

const PureHeader = () => {
  const dispatch = useAppDispatch();
  const { user, token } = useAppSelector((s) => s?.user);
  const { cartItems } = useAppSelector((state) => state.cart);

  const [modalConnexion, setModalConnexion] = useState(false);

  let [searchParams] = useSearchParams();

  const [searchCategory, setSearchCategory] = useState<any>();
  const [searchSousCategory, setSearchSousCategory] = useState<any>();

  const [query, setQuery] = React.useState({
    category: searchParams?.get("category") || "",
    min: searchParams?.get("min") || "",
    max: searchParams?.get("max") || "",
    orderBy: searchParams?.get("orderBy") || "",
  });

  const [value, setValue] = React.useState<any>({
    min: searchParams?.get("min") || 0,
    max: searchParams?.get("max") || 9000000,
  });

  let { state } = useLocation();

  const [show, setShow] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    dispatch(getTotalAmount());
  }, [cartItems]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <Navbar
        expand="lg"
        className="PureHeader-component headering "
        id="navbar"
      >
        <div
          className={`headering-second-level-header ${
            scrolled ? "scrolled" : ""
          }`}
        >
          {/* ── Logo Desktop ────────────────────────────────────────────── */}
          <Navbar.Brand
            href="/"
            className="d-flex align-items-center no-view-mobile"
          >
            <img
              src={PURE_Essence}
              alt="Pure Essence Botanicals"
              className="app-logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="no-view-mobile"
          />

          {/* ── Ligne mobile : Logo + Panier + Hamburger ────────────────── */}
          <div className="header-mobile-first-row no-view-desktop">
            <Navbar.Brand
              href="/"
              className="d-flex align-items-center header-mobile-brand"
            >
              <img
                src={PURE_Essence}
                alt="Pure Essence Botanicals"
                className="app-logo app-logo-mobile"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none";
                }}
              />
            </Navbar.Brand>

            <div className="header-mobile-icons-row">
              {/* Favoris mobile */}
              {/* <NavLink
                to={token ? "/mon-compte/favoris" : "#"}
                className="btn nav-link menu-link position-relative header-mobile-cart-link"
                aria-label="Favoris"
                onClick={
                  !token
                    ? (e) => {
                        e.preventDefault();
                        setModalConnexion(true);
                      }
                    : undefined
                }
              >
                <AiOutlineHeart size={22} className="header-mobile-cart-icon" />
              </NavLink> */}

              {/* Panier mobile → page panier */}
              <NavLink
                to="/panier"
                className="btn nav-link menu-link position-relative header-mobile-cart-link"
                aria-label="Panier"
              >
                
                <FiShoppingCart
                  className="header-mobile-cart-icon"
                  size={22}
                />
                <span className="counter-shop-notif counter-shop-notif-mobile">
                  {cartItems?.length ?? 0}
                </span>
              </NavLink>

              <Navbar.Toggle aria-controls="basic-navbar-nav" />
            </div>
          </div>

          {/* ── Menu déroulant (desktop + mobile collapse) ──────────────── */}
          <Navbar.Collapse id="basic-navbar-nav">
            {/* Liens nav mobile */}
            <div className="front-main-nav-mobile no-view-desktop">
             {MAIN_NAV_LINKS.map(({ to, label }) =>
  to === null ? (
    
     <a key={label}
      href="#categories"
      className="front-main-nav-mobile-link"
      onClick={(e) => {
        e.preventDefault();
        (document.querySelector(".navbar-toggler") as HTMLElement)?.click();
        document
          .getElementById("categories")
          ?.scrollIntoView({ behavior: "smooth" });
      }}
    >
      {label}
    </a>
  ) : (
    <NavLink
      key={label}
      to={to}
      className={({ isActive }) =>
        `front-main-nav-mobile-link${isActive ? " active" : ""}`
      }
      end={to === "/"}
      onClick={() =>
        (document.querySelector(".navbar-toggler") as HTMLElement)?.click()
      }
    >
      {label}
    </NavLink>
  )
)}
            </div>

            <Nav className="navbar navbar-expand-lg navbar-light firstheader-costum nav-header-custom">
              <div className="w-100 header-navbar-contents-container">
                {/* Recherche + catégories */}
                <div className="bloc-flex-info-user-header-content">
                  <div className="bloc-flex-info-user-header">
                    <div className="search-form-container no-view-mobile">
                      <SearchForm />
                    </div>
                    <div className="categorie-btn-container no-view-mobile">
                      <CategoriesList />
                    </div>
                  </div>
                </div>

                {/* Actions header droite */}
                <div className="container-nav-content-nvlink p-2">
                  {/* Mon Compte */}
                  <Nav.Link href="#compte">
                    {!token ? (
                      <button
                        onClick={() => setModalConnexion(true)}
                        className="btn nav-link menu-link d-flex align-items-center"
                      >
                        <FiUser size={18} />
                        <span className="ps-2 ">Se connecter</span>
                      </button>
                    ) : (
                      <NavLink
                        to="/mon-compte/profil"
                        className="btn nav-link menu-link"
                      >
                        <FiUser size={20} />
                        <span className="ps-2">Mon compte</span>
                      </NavLink>
                    )}

                    <ConnexionModal
                      modalConnexion={modalConnexion}
                      setModalConnexion={setModalConnexion}
                    />

                    <MobileCategoryModal
                      show={show}
                      setShow={setShow}
                      value={value}
                      setValue={setValue}
                      setSearchCategory={setSearchCategory}
                      setSearchSousCategory={setSearchSousCategory}
                      query={query}
                      setQuery={setQuery}
                      catgoryId={state?.catgoryId}
                    />
                  </Nav.Link>

                

                <NavLink
                                    to="/panier"
                                    className="btn nav-link menu-link position-relative no-view-mobile  d-flex align-items-center"
                                  >
                                    <span className="cart-icon-with-badge position-relative d-inline-flex align-items-center">
                                      <FiShoppingCart style={{ fontSize: 20 }} />
                                      <span className="counter-shop-notif">
                                        {cartItems?.length}
                                      </span>
                                    </span>
                                    <span className="ps-2">Panier</span>
                                  </NavLink>
                </div>
              </div>
            </Nav>
          </Navbar.Collapse>

          {/* Barre de recherche mobile */}
          <div className="container-menu-search-bloc-and-cart no-view-desktop position-relative mt-3">
            <div className="search-form-container header-mobile-search-wrapper">
              <SearchForm />
            </div>
          </div>
        </div>
      </Navbar>
    </div>
  );
};

export default PureHeader;